import { createContext, useContext } from 'react'

const AppDetailContext = createContext({
  app_type: '',
  name: '',
  description: '',
  brandImage: 'happyfox'
})

export const useAppDetailContext = () => useContext(AppDetailContext)

export default AppDetailContext
